import { render, staticRenderFns } from "./oldCustomerRepurchase.vue?vue&type=template&id=dc661c32&scoped=true&"
import script from "./oldCustomerRepurchase.vue?vue&type=script&lang=js&"
export * from "./oldCustomerRepurchase.vue?vue&type=script&lang=js&"
import style0 from "./oldCustomerRepurchase.vue?vue&type=style&index=0&id=dc661c32&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc661c32",
  null
  
)

export default component.exports